export const BLAND_DEFAULT_VOICE = 'Karen';

export const BLAND_VOICE_OPTIONS = [
  {
    value: 'Karen',
    label: 'Karen',
    description: 'Mature, steady support voice',
  },
  {
    value: 'Matthew',
    label: 'Matthew',
    description: 'Mature General American male voice',
  },
  {
    value: 'River',
    label: 'River',
    description: 'Light, friendly and conversational',
  },
] as const;

export function isBuiltInBlandVoice(value: string): boolean {
  return BLAND_VOICE_OPTIONS.some((voice) => voice.value === value);
}

/**
 * Alexa was the original Fabric default, but Bland's current curated default
 * is Karen. Treat the legacy value as an unset default while preserving every
 * explicit built-in or custom voice chosen by the user.
 */
export function normalizeBlandVoice(value?: string | null): string {
  const voice = value?.trim() ?? '';
  return !voice || voice.toLowerCase() === 'alexa'
    ? BLAND_DEFAULT_VOICE
    : voice;
}
